/**
 * Константы для способов оплаты
 */
export const PAYMENT_METHODS = [
    { value: 'cash', label: 'Оплата під час отримання товару' },
    { value: 'online', label: 'Оплата онлайн' },
];

